// @flow
import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import { Loader } from '@driftt/tide-core'
import { delay } from 'utils'
import { tracking } from '@driftt/traffic-control'
import { getImports } from 'api/contacts'
import ImportsTable from 'components/Imports/ImportsTable'
import ImportTableEmptyState from 'components/Imports/ImportTableEmptyState'
import Paginator from 'components/Paginator'


import './CSVstyle.css'

const Loading = ({ hasFinished }) => (
  <div className={classnames("imports-table-loader", {'imports-table-loader--loaded': hasFinished})}>
    <span>Finding your latest imports</span>
    <Loader />
  </div>
)

class CSVImports extends Component {

  state = {
    importsLoading: true,
    importsHasLoaded: false,
    isFetchingNew: false,
    size: 25,
    index: 0,
    totalPages: null,
    searchString: '',
    currentPage: 0
  }

  componentDidMount() {
    tracking.trackEvent('Contact Import Logs - Page Viewed')
    this.fetchImports()
  }

  setImportsLoaded = async () => {
    const start = () =>
      this.setState({
        importsHasLoaded: true,
        isFetchingNew: false,
      })

    const complete = () =>
      this.setState({
        importsLoading: false,
      })

    delay(start, 1200)
    delay(complete, 1200)


  }

  changeSize = ({ value }) => {
    this.setState({
      size: value
    }, this.fetchImports)
  }

  nextPage = () => {
    const { size, index } = this.state

    const newIndex = index + size

    this.setState(prevState => {
      const nextPage = prevState.currentPage + 1
      return {
        currentPage: nextPage,
        index: newIndex
      }
    }, this.fetchImports)
  } 

  previousPage = () => {
    const { size, index } = this.state

    const newIndex = index - size

    this.setState(prevState => ({
      currentPage: prevState.currentPage - 1,
      index: newIndex
    }), this.fetchImports)
  }

  fetchImports = async () => {
    const { size, index } = this.state
    const { onReceiveImports } = this.props

    try {
      const { data } = await getImports(size, index)
      
      onReceiveImports(data.summaries)

      this.setState({
        importsLoading: false,
        index: data.offset,
        totalPages: Math.ceil(data.totalCount / size)
      }, this.setImportsLoaded)

    } catch (err) {
      console.log(err)
    }
  }

  render() {
    const { isFetchingNew, importsLoading, importsHasLoaded, size, totalPages, currentPage } = this.state
    const { imports } = this.props

    return (
      <div className="imports-home">
        {importsLoading && <Loading hasFinished={importsHasLoaded} />}

        {isFetchingNew &&
          <span className="imports-home-table-fetcher">
            <Loader type="table" width={window.innerWidth - 60} />
          </span>
        }

        {!!imports &&
          <div className="imports-table-container">
            <ImportsTable
              hasFinished={importsHasLoaded}
              imports={imports}
            />
          </div>
        }

        {!!imports &&
          <Paginator
            totalPages={totalPages}
            size={size}
            goBackward={this.previousPage}
            goForward={this.nextPage}
            changeSize={this.changeSize}
            index={currentPage}
          />
        }

        {(!imports && importsHasLoaded) && 
          <Fragment>
            <ImportTableEmptyState/>
          </Fragment>
        }
      </div>
    )
  }
}

export default CSVImports
